import { RectangleMarkerRenderer } from '../rectangle/rectangleMarkerRenderer'

class SelectionMarkerRenderer extends RectangleMarkerRenderer {
  constructor(marker) {
    super(marker)
  }
}

export { SelectionMarkerRenderer }
